<template>
  <div>
    <div class="row">
      <div class="col-10">
        <TaskSummaryWidget :gridHeight="250" />
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="250">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/production/despatch#tab-summary">Despatch Summary Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/production/despatch#tab-panel-list">Despatch Panel Report</AnalyticsReportLink>
            <AnalyticsReportLink href="/analytics/reports/tasks/report#tab-task-item-list">Task Item List</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="680" large>
          <template v-slot:commoncontent>
            <div class="dashboard-filter-container">
              <div class="row no-gutters">
                <div class="col-6">
                  <ReportFilterPopover
                    headerTitle="Task Filter"
                    :showApplyButton="true"
                    :showResetButton="true"
                    :appendToBody="true"
                    alignment="left"
                    placement="bottom-end"
                    @apply="applyTaskFilter"
                    @reset="resetTaskFilter">
                    <template v-slot:popover>
                      <ReportDateRangeSelect 
                        :startDate="editingTaskFilter.startDate"
                        :endDate="editingTaskFilter.endDate"
                        @updateStartDate="editingTaskFilter.startDate = $event"
                        @updateEndDate="editingTaskFilter.endDate = $event"
                      />
                    </template>
                    <template v-slot:filterDisplay>
                      <div>
                        <i class="far fa-calendar mr-2"></i>{{appliedTaskFilter.startDate | formatDate}} - {{appliedTaskFilter.endDate | formatDate}}
                      </div>                
                    </template>
                  </ReportFilterPopover>
                </div>
                <!-- <div class="col-6 text-right">
                  <AnalyticsReportLink :href="`/analytics/reports/orders/ordervaluegroups#${fullReportTabId}`">View Full Report</AnalyticsReportLink>
                </div> -->
              </div>
            </div>
          </template>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-task-latearrivals-usercount">
              <i class="tabbedbox-tab-icon fas fa-user-clock"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Late Arrivals</div>
                <div class="tabbedbox-tab-subtitle">User Counts</div>
              </div>
            </Tab>
            <Tab tabid="tab-task-latearrivals-useravgduration">
              <i class="tabbedbox-tab-icon fas fa-user-clock"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Late Arrivals</div>
                <div class="tabbedbox-tab-subtitle">User Avg Time</div>
              </div>
            </Tab>
            <Tab tabid="tab-task-latearrivals-destinationcount">
              <i class="tabbedbox-tab-icon fas fa-map-marked-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Late Arrivals</div>
                <div class="tabbedbox-tab-subtitle">Destination Counts</div>
              </div>
            </Tab>
            <Tab tabid="tab-task-latearrivals-destinationavgduration">
              <i class="tabbedbox-tab-icon fas fa-map-marked-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Late Arrivals</div>
                <div class="tabbedbox-tab-subtitle">Destination Avg Time</div>
              </div>
            </Tab>
            <Tab tabid="tab-task-onsite-useravgduration">
              <i class="tabbedbox-tab-icon fas fa-stopwatch"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">On Site</div>
                <div class="tabbedbox-tab-subtitle">User Avg Time</div>
              </div>
            </Tab>
            <Tab tabid="tab-task-onsite-destinationavgduration">
              <i class="tabbedbox-tab-icon fas fa-stopwatch"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">On Site</div>
                <div class="tabbedbox-tab-subtitle">Destination Avg Time</div>
              </div>
            </Tab>
            
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-task-latearrivals-usercount" class="tabpage-padding-2">
              <TaskInfoChartWidget
                :type="TaskChartTypes.lateArrivalUserCount"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedTaskFilter.startDate"
                :endDate="appliedTaskFilter.endDate"
                :showDateFilter="false"
                @updateEditingStartDate="editingTaskFilter.startDate = $event"
                @updateEditingEndDate="editingTaskFilter.endDate = $event"
                @dateApplied="applyTaskFilter"
                @dateReset="resetTaskFilter"
              />
            </TabPage>
            <TabPage tabid="tab-task-latearrivals-useravgduration" class="tabpage-padding-2">
              <TaskInfoChartWidget
                :type="TaskChartTypes.lateArrivalUserAvgDuration"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedTaskFilter.startDate"
                :endDate="appliedTaskFilter.endDate"
                :showDateFilter="false"
                @updateEditingStartDate="editingTaskFilter.startDate = $event"
                @updateEditingEndDate="editingTaskFilter.endDate = $event"
                @dateApplied="applyTaskFilter"
                @dateReset="resetTaskFilter"
              />
            </TabPage>
            <TabPage tabid="tab-task-latearrivals-destinationcount" class="tabpage-padding-2">
              <TaskInfoChartWidget
                :type="TaskChartTypes.lateArrivalDestinationCount"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedTaskFilter.startDate"
                :endDate="appliedTaskFilter.endDate"
                :showDateFilter="false"
                @updateEditingStartDate="editingTaskFilter.startDate = $event"
                @updateEditingEndDate="editingTaskFilter.endDate = $event"
                @dateApplied="applyTaskFilter"
                @dateReset="resetTaskFilter"
              />
            </TabPage>
            <TabPage tabid="tab-task-latearrivals-destinationavgduration" class="tabpage-padding-2">
              <TaskInfoChartWidget
                :type="TaskChartTypes.lateArrivalDestinationAvgDuration"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedTaskFilter.startDate"
                :endDate="appliedTaskFilter.endDate"
                :showDateFilter="false"
                @updateEditingStartDate="editingTaskFilter.startDate = $event"
                @updateEditingEndDate="editingTaskFilter.endDate = $event"
                @dateApplied="applyTaskFilter"
                @dateReset="resetTaskFilter"
              />
            </TabPage>
            <TabPage tabid="tab-task-onsite-useravgduration" class="tabpage-padding-2">
              <TaskInfoChartWidget
                :type="TaskChartTypes.onSiteUserAvgDuration"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedTaskFilter.startDate"
                :endDate="appliedTaskFilter.endDate"
                :showDateFilter="false"
                @updateEditingStartDate="editingTaskFilter.startDate = $event"
                @updateEditingEndDate="editingTaskFilter.endDate = $event"
                @dateApplied="applyTaskFilter"
                @dateReset="resetTaskFilter"
              />
            </TabPage>
            <TabPage tabid="tab-task-onsite-destinationavgduration" class="tabpage-padding-2">
              <TaskInfoChartWidget
                :type="TaskChartTypes.onSiteDestinationAvgDuration"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedTaskFilter.startDate"
                :endDate="appliedTaskFilter.endDate"
                :showDateFilter="false"
                @updateEditingStartDate="editingTaskFilter.startDate = $event"
                @updateEditingEndDate="editingTaskFilter.endDate = $event"
                @dateApplied="applyTaskFilter"
                @dateReset="resetTaskFilter"
              />
            </TabPage>
            
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="630" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-tasktype-item-daily">
              <i class="tabbedbox-tab-icon fas fa-tags"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily Task Types</div>
                <div class="tabbedbox-tab-subtitle">Task Scanned Item Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-tasktype-area-daily">
              <i class="tabbedbox-tab-icon fas fa-tags"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily Task Types</div>
                <div class="tabbedbox-tab-subtitle">Task Scanned Area Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-taskuser-item-daily">
              <i class="tabbedbox-tab-icon fas fa-user"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily Task User</div>
                <div class="tabbedbox-tab-subtitle">Task Scanned Item Chart</div>
              </div>
            </Tab>
            <Tab tabid="tab-taskuser-area-daily">
              <i class="tabbedbox-tab-icon fas fa-user"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Daily Task User</div>
                <div class="tabbedbox-tab-subtitle">Task Scanned Area Chart</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-tasktype-item-daily" class="tabpage-padding-0">
              <TaskScannedItemDailyChartWidget :gridHeight="540" :embedded="true" :type="TaskDailyChartTypes.scannedItemTaskTypeQuantity" />
            </TabPage>
            <TabPage tabid="tab-tasktype-area-daily" class="tabpage-padding-0">
              <TaskScannedItemDailyChartWidget :gridHeight="540" :embedded="true" :type="TaskDailyChartTypes.scannedItemTaskTypeArea" />
            </TabPage>
            <TabPage tabid="tab-taskuser-item-daily" class="tabpage-padding-0">
              <TaskScannedItemDailyChartWidget :gridHeight="540" :embedded="true" :type="TaskDailyChartTypes.scannedItemPrimaryUserQuantity" />
            </TabPage>
            <TabPage tabid="tab-taskuser-area-daily" class="tabpage-padding-0">
              <TaskScannedItemDailyChartWidget :gridHeight="540" :embedded="true" :type="TaskDailyChartTypes.scannedItemPrimaryUserArea" />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import TaskSummaryWidget from '@/modules/intelligence/dashboardWidgets/taskSummaryWidget'
import OrderDespatchBreakdownWidget from '@/modules/intelligence/dashboardWidgets/orderDespatchBreakdownWidget'
import TaskScannedItemDailyChartWidget from '@/modules/intelligence/dashboardWidgets/taskScannedItemDailyChartWidget'
import TaskInfoChartWidget from '@/modules/intelligence/dashboardWidgets/taskInfoChartWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsTasksDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,

    TaskSummaryWidget,
    OrderDespatchBreakdownWidget,
    TaskScannedItemDailyChartWidget,
    TaskInfoChartWidget,

    ReportFilterPopover,
    ReportDateRangeSelect
  },
  data() {
    return {
      defaultTaskFilter: {    
        startDate: moment().local().subtract(6, 'month').startOf('day').toDate().toISOString(),
        endDate: moment().local().endOf('day').toDate().toISOString()
      },
      editingTaskFilter: {},
      appliedTaskFilter: {},      
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
    this.TaskDailyChartTypes = TaskScannedItemDailyChartWidget.TaskDailyChartTypes
    this.TaskChartTypes = TaskInfoChartWidget.TaskChartTypes
  },
  mounted() {
    this.editingTaskFilter = _.clone(this.defaultTaskFilter)
    this.appliedTaskFilter = _.clone(this.defaultTaskFilter)    
  },
  beforeDestroy() {
    
  },
  methods: {
    applyTaskFilter() {
      this.appliedTaskFilter = _.clone(this.editingTaskFilter)
    },
    resetTaskFilter() {
      this.editingTaskFilter = _.clone(this.defaultTaskFilter)
      this.appliedTaskFilter = _.clone(this.defaultTaskFilter)
    },
    
  }
  
}
</script>